// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.legal-footer {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem 0.75rem;
  align-items: center;
  justify-content: center;
  margin-top: 1.5rem;
  font-size: 0.85rem;
  color: var(--text-secondary, #9ca3af);
}

.legal-footer a {
  color: var(--brand-primary-light, #0a8cd8);
  text-decoration: underline;
  text-underline-offset: 2px;
}

.legal-footer a:hover,
.legal-footer a:focus-visible {
  color: var(--brand-primary, #0877bc);
}

.legal-footer a:focus-visible {
  outline: 2px solid var(--brand-primary, #0877bc);
  outline-offset: 2px;
  border-radius: 2px;
}

.legal-accept {
  display: flex;
  align-items: flex-start;
  gap: 0.65rem;
  margin: 1rem 0;
  text-align: left;
  font-size: 0.9rem;
  line-height: 1.4;
  color: inherit;
}

.legal-accept input {
  margin-top: 0.2rem;
  width: 1.1rem;
  height: 1.1rem;
  flex-shrink: 0;
}

.legal-accept a {
  color: var(--brand-primary, #0877bc);
}

.light-mode .legal-footer,
html[data-theme="light"] .legal-footer {
  color: #4b5563;
}

.light-mode .legal-footer a,
html[data-theme="light"] .legal-footer a {
  color: #065a8f;
}

.dark-mode .legal-footer,
html[data-theme="dark"] .legal-footer {
  color: #d1d5db;
}

.dark-mode .legal-footer a,
html[data-theme="dark"] .legal-footer a {
  color: #7dd3fc;
}
`, "",{"version":3,"sources":["webpack://./src/components/legal/LegalFooter.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,0CAA0C;EAC1C,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,gDAAgD;EAChD,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB","sourcesContent":[".legal-footer {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem 0.75rem;\n  align-items: center;\n  justify-content: center;\n  margin-top: 1.5rem;\n  font-size: 0.85rem;\n  color: var(--text-secondary, #9ca3af);\n}\n\n.legal-footer a {\n  color: var(--brand-primary-light, #0a8cd8);\n  text-decoration: underline;\n  text-underline-offset: 2px;\n}\n\n.legal-footer a:hover,\n.legal-footer a:focus-visible {\n  color: var(--brand-primary, #0877bc);\n}\n\n.legal-footer a:focus-visible {\n  outline: 2px solid var(--brand-primary, #0877bc);\n  outline-offset: 2px;\n  border-radius: 2px;\n}\n\n.legal-accept {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.65rem;\n  margin: 1rem 0;\n  text-align: left;\n  font-size: 0.9rem;\n  line-height: 1.4;\n  color: inherit;\n}\n\n.legal-accept input {\n  margin-top: 0.2rem;\n  width: 1.1rem;\n  height: 1.1rem;\n  flex-shrink: 0;\n}\n\n.legal-accept a {\n  color: var(--brand-primary, #0877bc);\n}\n\n.light-mode .legal-footer,\nhtml[data-theme=\"light\"] .legal-footer {\n  color: #4b5563;\n}\n\n.light-mode .legal-footer a,\nhtml[data-theme=\"light\"] .legal-footer a {\n  color: #065a8f;\n}\n\n.dark-mode .legal-footer,\nhtml[data-theme=\"dark\"] .legal-footer {\n  color: #d1d5db;\n}\n\n.dark-mode .legal-footer a,\nhtml[data-theme=\"dark\"] .legal-footer a {\n  color: #7dd3fc;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
